import React, { useState } from 'react';

const Findings = () => {
    // For Dismiss Button with Alert
    const [visible, setVisible] = useState(true);

    return (
            <div>
                <h2 className="mb-3">FINDINGS</h2>
            </div>
    );
}

export default Findings;
